import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { IAPI } from "../APIService";
import { buildQueryKey } from "@/utils/query";
import type { AxiosResponse } from "axios";
import { EndpointService } from "@/types/api/api";

export enum PrinterType {
  FOH = 0,
  KITCHEN = 1,
  BAR = 2,
  DELIVERY = 3,
  ALL = 4,
  FOH_WITHOUT_REQUESTS = 5,
  OTHER = 6,
  FOOD = 7,
  CUSTOM = 8,
}

export enum DeviceType {
  CLOUDPRNT = 0,
}

export enum PrintOnAcceptType {
  all = 0,
  epos = 1,
  mobile_ordering = 2,
  none = 3,
}

export interface IPrinter {
  id: string;
  active: boolean;
  categorise_items: boolean;
  print_on_accept: PrintOnAcceptType;
  custom_configuration: {
    id: number;
    created_at: string;
    number_of_menu_categories: number | null;
    number_of_menu_items: number | null;
    description: string;
    name: string;
    updated_at: string;
  };
  name: string;
  device_id: string;
  printer_type: PrinterType;
  device_type: DeviceType;
  updated_at: string;
  created_at: string;
  coursing_orders_only: string;
  open_cash_drawer: boolean;
  use_internal_menu_item_name: boolean;
  use_internal_modifier_item_name: boolean;
}

export interface IListPrinterParams {
  order_by?: string;
}

export interface IPrinterService {
  list: (params?: IListPrinterParams) => UseQueryResult<Array<IPrinter>, Error>;
}

export class PrinterService implements IPrinterService {
  api: IAPI;

  constructor(api) {
    this.api = api;
  }

  list(params?: IListPrinterParams): UseQueryResult<Array<IPrinter>, Error> {
    return useQuery({
      queryKey: buildQueryKey({
        queryKey: ["printers", "list"],
        venueID: this.api.selectedVenue,
        params: params,
      }),
      queryFn: async () => {
        const { data } = await this.api.get<AxiosResponse<Array<IPrinter>>>(
          "/printers/",
          {
            endpointService: EndpointService.Gateway,
            venueSpecific: true,
            params: params,
          },
        );
        return data;
      },
    });
  }
}
